// extracted by mini-css-extract-plugin
export default {"container":"Paragraph_container__73DGz"};